<template lang='pug' src='./home.pug'></template>

<script>
import ContentSections from 'components/custom/custom-home-sections/custom-home-sections'
import BgVideo from 'components/custom/custom-bg-video/custom-bg-video'
// import Intro from 'components/custom/custom-intro/custom-intro'
import Hero from 'components/hero/hero'
import Loader from 'components/loader/loader'
import OfficeTour from 'components/custom/custom-meet-slider/custom-meet-slider'
import Reviews from 'components/custom/custom-home-reviews/custom-home-reviews'
import Slider from 'components/custom/custom-home-slider/custom-home-slider'
// import TabSection from 'components/custom/custom-tab-section/custom-tab-section'
// import VideoModal from 'components/modal/video-modal/video-modal'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    BgVideo,
    ContentSections,
    Hero,
    // Intro,
    Loader,
    OfficeTour,
    Reviews,
    Slider
    // TabSection,
    // VideoModal
  }
}
</script>



// WEBPACK FOOTER //
// home.vue?68329768